<div [formGroup]="form">
    <cmps-button-group
        [formControlName]="'periodType'"
        #bgRef
    >
        <ng-container *ngFor="let i of periodTypeOpts">
            <button
                [class.cmps-cdk-border-color-blue-100]="bgRef.value === i.value"
                [class.cmps-cdk-bg-color-blue-100]="bgRef.value === i.value"
                [class.cmps-cdk-color-white]="bgRef.value === i.value"
                cmpsButtonGroupItem
                [value]="i.value"
            >
                {{ i.tlKey | translate }}
            </button>
        </ng-container>
    </cmps-button-group>

    <div
        class="mt-3"
        *ngIf="cacheDates"
    >
        <label
            class="mr-3 mb-0"
            id="insightDateRange"
            >{{ i18n._709_DATE_RANGE | translate }}</label
        >
        <div class="d-inline-block">
            <div
                class="input-group"
                [hidden]="periodType !== PeriodType.DAY"
            >
                <input
                    class="form-control"
                    [placeholder]="i18n._646_YYYY_MM_DD | translate"
                    aria-labelledby="insightDateRange"
                    ngbDatepicker
                    [markDisabled]="invalidEventDate"
                    [formControlName]="'eventDateDay'"
                    #dp="ngbDatepicker"
                />
                <div class="input-group-append">
                    <button
                        type="button"
                        class="btn btn-secondary cmps-cdk-py-0dot5"
                        aria-label="Toggle date picker"
                        [attr.aria-expanded]="dp.isOpen()"
                        (click)="dp.toggle()"
                    >
                        <cmps-icon svgIcon="calendar"></cmps-icon>
                    </button>
                </div>
            </div>
            <ng-select
                [hidden]="periodType === PeriodType.DAY"
                [options]="eventDateOpts"
                [placeholder]="'&nbsp;'"
                [ariaLabelledBy]="'insightDateRange'"
                [formControlName]="'eventDate'"
            ></ng-select>
        </div>
    </div>
</div>
